/**
 * The angularjs states related to the module AddAccountModule
 */
googleBusinessProfileStates.$inject = ['$stateProvider'];
export function googleBusinessProfileStates($stateProvider) {

  $stateProvider
    .state('auth.alcmeon.parameters.gmb', {
      abstract: true,
      url: '/gmb',
    })
    .state('auth.alcmeon.parameters.gmb.add-account', {
      url: '/{requestId:int}/accounts',
      views: {
        'container@auth': {
          template: require('../../../../ajs-app/components/parameters/addAccountGmb/addAccountGMB.html'),
          controller: 'AddAccountGMBController'
        }
      }
    })
    .state('auth.alcmeon.parameters.gmb.add-account.add-locations', {
      url: '/{accountId}/locations',
      params: {
        accountId: null,
        companyId: null,
        requestId: null
      },
      views: {
        'container@auth': {
          template: '<angular-google-business-profile-locations></angular-google-business-profile-locations>',
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.google-business-profile', {

      abstract: true,
      url: '/google-business-profile',
    })
    .state('auth.alcmeon.fuse.parameters.google-business-profile.first-connection', {
      url: '/first-connection',
      views: {
        'container@auth': {
          template: '<angular-google-business-profile-first-connection></angular-google-business-profile-first-connection>',
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.google-business-profile.login', {
      url: '/login',
      resolve: {
        googleAccountAttachedToAlcmeon: ['AngularGoogleBusinessProfileService',
          function (AngularGoogleBusinessProfileService) {
            return AngularGoogleBusinessProfileService.getExistingGoogleAccountAttachedToAlcmeon().toPromise();
          }]
      },
      views: {
        'container@auth': {
          controller: ['$scope', '$state', '$q', 'googleAccountAttachedToAlcmeon', function ($scope, $state, $q, googleAccountAttachedToAlcmeon) {
            if (!googleAccountAttachedToAlcmeon) {
              $state.go('auth.alcmeon.fuse.parameters.google-business-profile.first-connection');
              return $q.reject();
            }
            $scope.googleAccountAttachedToAlcmeon = googleAccountAttachedToAlcmeon;
          }],
          template: '<angular-google-business-profile-login [google-account-attached-to-alcmeon]="googleAccountAttachedToAlcmeon"></angular-google-business-profile-login>',
        }
      }
    })
    ;
}
